export default "/assets/fonts/Graphik-Medium.a2a6cfd78549c3cc724560e4a2cc23d1.woff2";